/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Addmore2Inputs */

const zh_organizationsettings_addmore2 = /** @type {(inputs: Organizationsettings_Addmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加更多`)
};

const en_organizationsettings_addmore2 = /** @type {(inputs: Organizationsettings_Addmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add more`)
};

const es_organizationsettings_addmore2 = /** @type {(inputs: Organizationsettings_Addmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar más`)
};

/**
* | output |
* | --- |
* | "Add more" |
*
* @param {Organizationsettings_Addmore2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_addmore2 = /** @type {((inputs?: Organizationsettings_Addmore2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Addmore2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_addmore2(inputs)
	if (locale === "en") return en_organizationsettings_addmore2(inputs)
	return es_organizationsettings_addmore2(inputs)
});
export { organizationsettings_addmore2 as "organizationSettings_addMore" }